import React, { ReactNode } from "react";
import styled from "styled-components";

const StyledItem = styled.div<{
  disabled?: boolean;
}>`
  display: flex;
  gap: 1rem;
  cursor: pointer;
  /* background-color: #f7f7f7; */
  transition: background-color 0.2s ease-in-out;
  padding: 1rem 0.8rem;
  color: #333;

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
    `}

  &:hover {
    background-color: #eaeaea;
  }
`;

const ItemInput = styled.div``;
const ItemMain = styled.div``;
const ItemText = styled.div``;
const ItemHelperText = styled.div``;

const Item = ({
  multiple,
  checked,
  disabled,
  label,
  helperText,
  onClick,
  ...props
}: {
  multiple?: boolean;
  checked?: boolean;
  disabled?: boolean;
  label: ReactNode;
  helperText?: string;
  onClick?: () => void;
}) => {
  return (
    <StyledItem
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      {...props}
    >
      <ItemInput>
        <input
          type={multiple ? "checkbox" : "radio"}
          checked={checked}
          disabled={disabled}
        />
      </ItemInput>
      <ItemMain>
        <ItemText>{label}</ItemText>
        {helperText && <ItemHelperText>{helperText}</ItemHelperText>}
      </ItemMain>
    </StyledItem>
  );
};

const Styled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const CheckboxListInput: React.FC<React.PropsWithChildren<object>> & {
  Item: typeof Item;
} = ({ children, ...props }) => {
  return <Styled {...props}>{children}</Styled>;
};

CheckboxListInput.Item = Item;

export default CheckboxListInput;
